export const CHANGE_TAB = 'BEAMLY/CCX/CHANGE_TAB';
